import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const userManagement = {
  path: "user-management",
  getLink: () => buildPath([root.path, userManagement.path]),
  permissions: [
    PermissionEnum.USER_MANAGEMENT_ACCESS,
    PermissionEnum.ROLE_MANAGEMENT_ACCESS,
    PermissionEnum.DEPARTMENT_MANAGEMENT_ACCESS,
  ],
  users: {
    path: "users",
    getLink: () => buildPath([userManagement.path, userManagement.users.path]),
    permissions: [PermissionEnum.USER_MANAGEMENT_ACCESS],
  },
  roles: {
    path: "roles",
    getLink: () => buildPath([userManagement.path, userManagement.roles.path]),
    permissions: [PermissionEnum.ROLE_MANAGEMENT_ACCESS],
  },
  departments: {
    path: "departments",
    getLink: () => buildPath([userManagement.path, userManagement.departments.path]),
    permissions: [PermissionEnum.DEPARTMENT_MANAGEMENT_ACCESS],
  },
};
